module.exports = __webpack_public_path__ + "img/aac.908a8af0.png";